import React, { FC, useEffect, useState } from 'react';

import { Clients, Entities } from '@ariksa/notification';
import { each, includes, isEmpty, some } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from 'components/DataEntry/Form';
import { selectAlertWorkflow } from 'containers/PolicyHub/AlertWorkflow/selectors';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { actions as sharedStateActions } from 'containers/SharedState/slice';

import { useAlertWorkflowWizardContext } from '../AlertWorkflowWizardContext';

import { AlertActions } from './AlertActions';
import { AlertConditions } from './AlertConditions';
import { AlertTriggers } from './AlertTriggers';

interface Props {}

export const AlertWorkflowConditions: FC<Props> = props => {
  const {
    handleSubmit,
    handleBack,
    onCancel,
  } = useAlertWorkflowWizardContext();
  const dispatch = useDispatch();
  const {
    formData,
    alertConditions,
    tagKeyValues,
    jiraClients,
    jiraMandatoryFields,
    jiraClientsRequiredFields,
  } = useSelector(selectAlertWorkflow);
  const { clients: integrationClients } = useSelector(selectIntegrations);
  const [isDisabledNext, setIsDisabledNext] = useState(true);
  const { trigger, clients } = formData;

  //load and tags
  useEffect(() => {
    dispatch(
      sharedStateActions.getTagKeys({
        q: {},
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    const hasJiraClient = some(clients, { client_name: Clients.Jira });
    let isAnyJIRAFieldEmpty = false;
    each(jiraClients, (clientConfig, clientName) => {
      if (isAnyJIRAFieldEmpty) return;
      each(clientConfig, (value, key) => {
        if (
          isEmpty(value) &&
          jiraClientsRequiredFields?.[clientName]?.includes(key)
        ) {
          isAnyJIRAFieldEmpty = true;
          return;
        }
      });
    });
    setIsDisabledNext(
      isEmpty(trigger) ||
        isEmpty(alertConditions) ||
        isEmpty(clients) ||
        some(
          alertConditions,
          o => isEmpty(o.entity_list) && o.name !== Entities.Tags,
        ) ||
        (isAnyJIRAFieldEmpty && hasJiraClient) ||
        (includes(Object.keys(alertConditions), Entities.Tags) &&
          (some(tagKeyValues, o => isEmpty(o.entity_list)) ||
            isEmpty(tagKeyValues))),
    );
  }, [
    trigger,
    alertConditions,
    clients,
    tagKeyValues,
    jiraClients,
    jiraClientsRequiredFields,
  ]);

  return (
    <Form
      styles={{ form: { container: { w: '680px', my: 4 } } }}
      title="Set Conditions"
      buttonOptions={{
        submit: {
          name: 'Next',
          isDisabled:
            isDisabledNext ||
            some(jiraMandatoryFields, { isLoading: true }) ||
            integrationClients.loading,
          isLoading: some(jiraMandatoryFields, { isLoading: true }),
        },
        reset: {
          name: 'Cancel',
          isVisible: true,
          onClick: onCancel,
        },
        back: {
          isVisible: true,
          onClick: () => handleBack?.(),
        },
      }}
      handleSubmit={handleSubmit}
    >
      {/*When Part*/}
      <AlertTriggers />

      {/*If Part*/}
      <AlertConditions />

      {/*Then Part*/}
      <AlertActions />
    </Form>
  );
};
